import { CollaboratorValidationSchema } from "@/shared";
import * as Yup from "yup";

export function useCollaboratorOnboardingSchema() {
  return CollaboratorValidationSchema().shape({
    address: Yup.string().max(255, "O endereço deve ter no máximo 255 caracteres.").optional(),
    payment: Yup.string().max(255, "A chave PIX deve ter no máximo 255 caracteres.").optional(),
  });
}
